import type { FC } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { useQuery } from '@apollo/client/react';

import { COLORS, mq } from '@clutter/clean';

import type { PageQuery } from '@graphql/platform';
import { PolygonsDocument } from '@graphql/platform';

import type { GeomGeoJSON } from '@shared/map/geom';

import { Map } from '../shared/map';
import { PageContent } from './shared';

const PageMapWrapper = styled.div`
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
  background: ${COLORS.cloud};
  width: 100%;
  overflow: hidden;
  ${mq({
    borderRadius: ['6px', '18px'],
    height: ['347px', '440px'],
    marginTop: ['0', '60px'],
  })}
`;

export const PageMap: FC<{
  page: PageQuery['page'];
}> = ({ page }) => {
  if (!page) throw new Error('missing page');

  const { latitude, longitude } = page;
  const { data } = useQuery(PolygonsDocument);
  const center = {
    lat: latitude,
    lng: longitude,
  };
  const geom = data?.geom as GeomGeoJSON | undefined;

  return (
    <PageContent>
      <PageMapWrapper>
        <Map center={center} geom={geom} />
      </PageMapWrapper>
    </PageContent>
  );
};
